import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      style={{ zIndex: 10000, position: 'fixed' }}
      toastOptions={{
        classNames: {
          toast: "group toast bg-white text-gray-900 border border-gray-200 shadow-lg",
          description: "text-gray-600",
          actionButton: "bg-purple-600 text-white",
          cancelButton: "bg-gray-100 text-gray-600",
        },
        style: {
          zIndex: 10000,
          background: 'white',
          color: '#111827',
          border: '1px solid #e5e7eb'
        }
      }}
      {...props} />
  );
}

export { Toaster, toast }
